import type { TabsProps } from 'antd';
import { type FC, useState } from 'react';
import Tab from '../../../../components/Tabs/Tab';
import LADClaimsDetailsTab from './Details/LADClaimsDetailsTab';
import LADClaimsFilesTab from './Files/LADClaimsFilesTab';
import LADClaimFinancialsTab from './Financials/LADClaimFinancialsTab';
import LADClaimsItemsTab from './Items/LADClaimsItemsTab';
import LADClaimsNotesTab from './Notes/LADClaimsNotesTab';
import LADSettlementsTab from './Settlements/LADSettlementsTab';

const LADEditTabs: FC = () => {
  const [activeEditTab, setActiveEditTab] = useState<TabsProps['activeKey']>('1');

  const handleTabChange: TabsProps['onChange'] = (val) => {
    setActiveEditTab(val);
  };

  return (
    <Tab
      onChange={handleTabChange}
      contents={[
        {
          title: 'Details',
          content: <LADClaimsDetailsTab />,
          contentKey: '1',
        },
        {
          title: 'Claim Items',
          content: <LADClaimsItemsTab />,
          contentKey: '2',
        },
        {
          title: 'Claim Financials',
          content: <LADClaimFinancialsTab />,
          contentKey: '3',
        },
        {
          title: 'Claim Notes',
          content: <LADClaimsNotesTab />,
          contentKey: '4',
        },
        {
          title: 'Upload/View Files',
          content: <LADClaimsFilesTab />,
          contentKey: '5',
        },
        {
          title: 'Claim Settlements',
          content: <LADSettlementsTab />,
          contentKey: '6',
        },
      ]}
      defaultActiveKey="1"
      activeKey={activeEditTab}
    />
  );
};

export default LADEditTabs;
